import { upperCase } from 'lodash-es';
import vest, { test, enforce } from 'vest';
import isEmail from 'validator/lib/isEmail';
import { internalRoutePaths } from '../../../config/config';

enforce.extend({
  isValidEmail: (value) => isEmail(value),
});

const formValidation = vest.create((data = {}) => {
  const { password, email } = data;

  test('email', 'the_email_field_is_required_', () =>
    enforce(email).isNotEmpty()
  );
  test('email', 'form_msg_email_not_valid', () =>
    enforce(email).isValidEmail()
  );

  test('password', 'the_password_field_is_required_', () =>
    enforce(password).isNotEmpty()
  );
  test('password', 'password_8_characters', () =>
    enforce(password).longerThan(7)
  );
});

const relocateUser = (userData, history, defaultRoute) => {
  const landingPage = userData?.client?.settings?.landing_page;

  const route =
    (internalRoutePaths[upperCase(landingPage)] ||
      internalRoutePaths[upperCase(landingPage?.slice(0, -1))]) ??
    defaultRoute;

  history.push(route);
};

export { formValidation, relocateUser };
